import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { UserDto, UserRole } from '@fleet-beat/core';
import { AuthService, RedirectService } from '@fleet-beat/shared';

@Injectable()
export class BackToAdminGuard implements CanActivate {
  constructor(private authService: AuthService, private redirectService: RedirectService, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const user: UserDto = this.authService.authUser;
    if (user.role !== UserRole.Admin && this.authService.hasAdminAuthenticated) {
      this.authService.replaceUserWithAdmin(state.url);
      return false;
    }
    if (user.role !== UserRole.Admin) {
      this.redirectService.navigate(['/']);
      return false;
    }
    return true;
  }
}
